import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Role } from './roles';

/** Route guard factory: only lets the route activate for users holding the given role. */
export function requireRole(role: Role): CanActivateFn {
  return (_, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (!authService.isAuthenticated()) {
      return router.createUrlTree(['/login'], {
        queryParams: {
          returnUrl: state.url,
        },
      });
    }

    if (authService.hasRole(role)) {
      return true;
    }

    return router.createUrlTree(['/dashboard']);
  };
}
